if (typeof ProductItem !== 'function') {
  window.ShopSanteProductItemCache = window.ShopSanteProductItemCache || new Map()

  class ProductItem extends HTMLElement {
    constructor() {
      super()
      this.handle = this.getAttribute('data-js-product-item')
      this.requestId = 0
      if (this.querySelector('variant-selector')) {
        this.init()
      }
    }
    init() {
      this.addEventListener('variant-selector:changed', async (event) => {
        const { id } = event.detail
        const url = new URL(window.location.origin + window.Shopify.routes.root)
        url.searchParams.set('view', 'item')
        url.searchParams.set('variant', id)
        url.pathname = url.pathname + 'products' + '/' + this.handle

        const requestId = ++this.requestId
        this.setAttribute('aria-busy', 'true')

        try {
          const cacheKey = url.toString()
          let htmlPromise = window.ShopSanteProductItemCache.get(cacheKey)

          if (!htmlPromise) {
            htmlPromise = fetch(url, {
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            }).then((response) => {
              if (!response.ok) throw new Error(`Product card request failed: ${response.status}`)
              return response.text()
            })
            window.ShopSanteProductItemCache.set(cacheKey, htmlPromise)
            htmlPromise.catch(() => window.ShopSanteProductItemCache.delete(cacheKey))
          }

          const htmlString = await htmlPromise
          if (requestId !== this.requestId) return

          const domElement = new DOMParser().parseFromString(htmlString, 'text/html')
          const nextImage = domElement.querySelector('[data-js-replace="image"]')
          const nextText = domElement.querySelector('[data-js-replace="text"]')
          const image = this.querySelector('[data-js-replace="image"]')
          const text = this.querySelector('[data-js-replace="text"]')

          if (image && nextImage) image.innerHTML = nextImage.innerHTML
          if (text && nextText) text.innerHTML = nextText.innerHTML
        } catch (error) {
          console.error(error)
        } finally {
          if (requestId === this.requestId) this.removeAttribute('aria-busy')
        }
      })
    }
  }

  if (typeof customElements.get('product-item') == 'undefined') {
    customElements.define('product-item', ProductItem)
  }
}
